import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => [{ title: "Terms of Service – Ecofo" }];

export default function TermsOfService() {
  return (
    <div className="text-white min-h-screen overflow-auto" style={{ backgroundColor: '#050B0A' }}>
      <div className="container mx-auto px-6 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
        <p className="text-gray-400 mb-10 text-sm">Last updated: March 2026</p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
          <p className="text-gray-300 leading-relaxed">
            By accessing or using Ecofo ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">2. Use of the Service</h2>
          <p className="text-gray-300 leading-relaxed">
            You agree to use the Service only for lawful purposes and in accordance with these Terms. You must not misuse, reverse-engineer, or attempt to gain unauthorized access to any part of the Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">3. Accounts</h2>
          <p className="text-gray-300 leading-relaxed">
            You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Notify us immediately of any unauthorized use.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">4. Content</h2>
          <p className="text-gray-300 leading-relaxed">
            You retain ownership of content you submit. By submitting content, you grant Ecofo a limited license to store, display, and deliver that content as part of operating the Service. You are solely responsible for ensuring your content does not violate any third-party rights.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">5. Termination</h2>
          <p className="text-gray-300 leading-relaxed">
            We reserve the right to suspend or terminate your access to the Service at our discretion, with or without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">6. Disclaimer of Warranties</h2>
          <p className="text-gray-300 leading-relaxed">
            The Service is provided "as is" without warranties of any kind. We do not guarantee uninterrupted or error-free operation.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">7. Limitation of Liability</h2>
          <p className="text-gray-300 leading-relaxed">
            To the fullest extent permitted by law, Ecofo shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">8. Changes to Terms</h2>
          <p className="text-gray-300 leading-relaxed">
            We may update these Terms at any time. Continued use of the Service after changes are posted constitutes acceptance of the new Terms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">9. Contact</h2>
          <p className="text-gray-300 leading-relaxed">
            Questions about these Terms? Email us at <span className="text-green-400">admin &lt;at&gt; ecofo.org</span>.
          </p>
        </section>
      </div>
    </div>
  );
}
